import React, { Component } from 'react'
import { Card, CardHeader, CardBody, Button, CardFooter, Form, FormGroup, Label, Input, } from 'reactstrap'
import { db } from '../../../config/firebaseconfig'
import timestamper from '../../../helpers/timestamper'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as manageEducatorsActionCreators from '../../../redux/modules/manageEducators'
import generateUniqueShortId from '../../../helpers/users/generateUniqueShortId';
import { Nav } from './ManagePane';

/* ManageStudents
  
  <StudentRegistrationCodeModal
    isOpen={this.props.modal === 'studentRegistrationCode'}
    key='StudentRegistrationCodeModal'
    toggle={this.props.closeModal}
    selectedSchool={this.props.selection.school}
    schools={this.props.schools}
  />

  Really need to refactor this and tie it all in to redux correctly

  assume additional prop: 

  role={'teacher'} || role={'student'}

  */

class ManageStudentsCodes extends Component {
  constructor(props) {
    super(props)

    this.state = {
      number: 1,
      isSaving: false,
      isSavingError: false,
      isFetchingRegistrationCode: false,
      registrationCode: null,
      isFetchingRegistrationCodeError: false,
      isDeleting: false,
      isDeletingError: false,
    }

    this.subscribeToCode = this.subscribeToCode.bind(this)
  }

  componentDidMount() {
    //needs to be pushed to redux
    if (this.props.schools) {
      const { id } = this.props.match.params
      const school = this.props.schools[id]
      this.subscribeToCode(school[`${this.props.role}RegistrationCode`])
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.schools && this.props.schools) {
      const { id } = this.props.match.params
      const school = this.props.schools[id]
      this.subscribeToCode(school[`${this.props.role}RegistrationCode`])
    }
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  subscribeToCode(registrationCode) {
    if (registrationCode) {
      this.setState({isFetchingRegistrationCode: true,})
      this.unsubscribe = db.collection('registrationCodes').doc(registrationCode)
        .onSnapshot((doc) => {
          if (doc.exists) {
            this.setState({
              registrationCode: doc.data(),
              isFetchingRegistrationCode: false,
              number: doc.data().limit,
            })
          } else {
            this.setState({
              registrationCode: null,
              isFetchingRegistrationCode: false,
            })
          }
        }, 
        (err) => {
          this.setState({
            isFetchingRegistrationCode: false, 
            isFetchingRegistrationCodeError: true,
          })
        })
    }
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value})
  }

  /*
    If no registration code exists, generate an id, verify it's unique, and then add it to registrationCodes and to the school record along with uses number
    If registration code exists but is expired, say so and then allow registration code re-generation
    If code does exist, explain how to use it and show how many people can use it

    Eventually limit the number of uses of the registration code and show how many people have used it
  */


  
  generateCode() {
    const selectedSchool = this.props.match.params.id
    const school = this.props.schools[selectedSchool]
    this.setState({isSaving: true})
    // generate that is verified unique
    generateUniqueShortId()
      .then((id) => {
        const time = timestamper()
        const batch = db.batch()
        const registrationCodesRef = db.collection('registrationCodes').doc(id)
        const schoolRef = db.collection('schools').doc(selectedSchool)
        let role
        let schoolUpdateKey
        if (this.props.role === 'student') {
          role = 'Student'
          schoolUpdateKey = 'studentRegistrationCode'
        } else if (this.props.role === 'teacher') {
          role = 'Teacher'
          schoolUpdateKey = 'teacherRegistrationCode'
        }
        const newRegistrationCode = {
          id,
          created: time,
          expiration: time + 31536000000, //365 days
          state: school.state,
          district: school.district,
          school: school.id,
          limit: parseInt(this.state.number),
          uses: 0,
          users: {},
          role,
        }
        batch.set(registrationCodesRef, newRegistrationCode)

        batch.set(schoolRef, {[schoolUpdateKey]: id}, {merge: true})
        batch.commit()
          .then(() => {
            this.setState({isSaving: false, number: 1, registrationCode: newRegistrationCode})
            this.props.updateSchool(selectedSchool, schoolUpdateKey, id)
            this.subscribeToCode(id)
          })
          .catch((err) => {
            this.setState({isSaving: false, isSavingError: true})
          })


      })
  }

  updateUsesLimit() {
    this.setState({isSaving: true,})
    db.collection('registrationCodes').doc(this.state.registrationCode.id).update({
      limit: this.state.number,
    })
      .then(() => this.setState({isSaving: false, }))
      .catch((err) => this.setState({isSaving: false, isSavingError: true,}))
  }

  deleteCode() {
    const schoolId = this.props.match.params.id
    this.setState({isDeleting: true,})
    const batch = db.batch()
    const schoolRef = db.collection('schools').doc(schoolId)
    const registrationCodeRef = db.collection('registrationCodes').doc(this.state.registrationCode.id)
    let schoolUpdateKey
    if (this.props.role === 'student') {
      schoolUpdateKey = 'studentRegistrationCode'
    } else if (this.props.role === 'teacher') {
      schoolUpdateKey = 'teacherRegistrationCode'
    }
    batch.update(schoolRef, {[schoolUpdateKey]: ''})
    batch.update(registrationCodeRef, {deleted: true})
    batch.commit()
      .then(() => {
        this.setState({isDeleting: false, registrationCode: null})
        this.props.updateSchool(schoolId, schoolUpdateKey, '')
      })
      .catch((err) => {
        this.setState({isDeleting: false, isDeletingError: true,})
      })
  }

  render() {

    let submitButton = (
      <Button 
        color='primary'
        onClick={() => this.generateCode()}
      >
        {this.state.isSaving ? <i className="fa fa-spinner fa-lg fa-spin"></i> : 'Generate Code'}
      </Button>
    )
    
    let cardBody = (
      <div>
        <p>{`Generate a registration code that ${this.props.role}s can use at our `}<Link to='/register'>registration page</Link>.</p>
        <Form>
          <FormGroup>
            <Label htmlFor='number'>How many uses do you authorize?</Label>
            <Input
              type='number'
              id='number'
              name='number'
              placeholder='17'
              onChange={(e) => this.handleChange(e)}
              value={this.state.number}
            />
          </FormGroup>
        </Form>
      </div>
    )

    if (this.state.registrationCode) {
      const registrationCode = this.state.registrationCode
      const timeNow = timestamper()
      if (registrationCode.expiration < timeNow) {
        // expired code screen
        
      } else {
        // active code screen
        cardBody = (
          <div>
            <h4>{registrationCode.id}</h4>
            <p>This school's registration code is <b>{registrationCode.id}</b></p>
            <p>This code has been used <b>{registrationCode.uses}</b> times out of <b>{registrationCode.limit}</b> total uses.</p>
            <p>{`Your ${this.props.role}s can go to www.masteryprep.com/register to use the code, or you can email them `}<Link to={`/register/${registrationCode.id}`}>this link</Link>.</p>
            <Form>
              <FormGroup>
                <Label htmlFor='number'>Change registration limit for this code</Label>
                <Input
                  type='number'
                  id='number'
                  name='number'
                  placeholder='17'
                  onChange={(e) => this.handleChange(e)}
                  value={this.state.number}
                />
              </FormGroup>
            </Form>
          </div>
        )

        submitButton = (
          <div>
            <Button
              color='primary'
              onClick={() => this.updateUsesLimit()}
            >
              {this.state.isSaving ? <i className="fa fa-spinner fa-lg fa-spin"></i> : 'Update Limit'}
            </Button>
            <Button
              className='ml-2'
              color='danger'
              onClick={() => this.deleteCode()}
            >
              {this.state.isDeleting ? <i className="fa fa-spinner fa-lg fa-spin"></i> : 'Delete Code'}
            </Button>
          </div>
        )
      }
    }

    let headerText
    if (this.props.role === 'student') {
      headerText = 'Student Registration Code'
    } else if (this.props.role === 'teacher') {
      headerText = 'Teacher Registration Code'
    }
  
    return (
      <Card>
        <CardHeader>
          {headerText}
        </CardHeader>
        <CardBody>
          {cardBody}
        </CardBody>
        <CardFooter>
          {this.state.isSavingError || this.state.isDeletingError ? 'Error saving code information.' : ''}
          {submitButton}
          <Nav back={`/users/manage/${this.props.role}s/${this.props.match.params.id}`}/>
        </CardFooter>
      </Card>
    )
  }
}

export default connect(
  (state) => ({
    schools: state.manageEducators.schools,
  }),
  (dispatch) => bindActionCreators(manageEducatorsActionCreators, dispatch)
)(ManageStudentsCodes)


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManageStudentsCodes.js